import React, { useState } from 'react';
import {
  Form,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Spin,
  Typography,
  Divider,
  Select,
  Collapse,
  DatePicker,
  Upload,
  InputLink,
  InputNumber
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import '../../components/Common/Form.css';
import { beforeImageUpload } from '../../utilities/imageUpload';
import ImageUploadSection from '../../components/ImageUploadSection';
import { dayOfWeekMapInverse } from '../../utilities/constants';
import moment from 'moment';
const { Text } = Typography;
const { TextArea } = Input;
const { Panel } = Collapse;

const { Option } = Select;
export const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';
export const FREE_WORKSHOP_COURSE_PRICE_TYPE = 'Type 0';

const COURSE_WORKSHOP_DEFAULTS = {
  isActive: false,
  isPublic: true,
  mode: 'freeworkshop',
  type: 'daily',
  domainAccess: ['all'],
  categories: {
    'Free Workshops': []
  },
  customCardMetadata: [
    {
      type: 'meet-creator-note',
      sectionNumber: 0,
      position: 1,
      data: {
        imgData: {
          mobileImgData: {
            src: ''
          },
          desktopImgData: {
            src: ''
          }
        }
      }
    }
  ]
};

const COURSE_OFFER_WORKSHOP_DEFAULTS = {
  courseOfferStatus: 'Pending',
  location: '',
  classMaterialsLink: '',
  whatToBring: '',
  doesGraduate: true,
  isActive: true,
  isSpecial: false,
  showPrice: false,
  specialMessage: '',
  generalNotes: '',
  type: 'freeWorkshop',
  maxRegistrations: 100000,
  minRegistrations: 1,
  whatsappGroupLinks: 'https://web.whatsapp.com'
};

const SUBUNIT_WORKSHOP_DEFAULTS = {
  title: 'Certificate',
  sectionNumber: 3
};

const CERTIFICATE_WORKSHOP_DEFAULTS = {
  title: 'Certificate',
  criteriaWiseResponse: [
    {
      noOfCriteriasMet: 0,
      title: 'Get Started! 🚀',
      description: [
        {
          text:
            'Complete the steps below to unlock your personalised certificate'
        }
      ]
    },
    {
      noOfCriteriasMet: 1,
      title: 'Certificate of Accomplishment',
      description: [
        {
          text: 'You did it! Now go and change the world.'
        },
        {
          text: '',
          isNewLine: true
        },
        {
          text: 'Get your personalised certificate.'
        }
      ]
    }
  ],
  criteria: [
    {
      text: 'Complete Feedback',
      type: 'feedback',
      requirement: {
        type: 'status',
        value: 'completed'
      }
    }
  ]
};

export const renderSubunitForFreeWorkshop = (form, setStatus) => {
  return (
    <>
      <Collapse>
        <Panel
          header="Certificate Image - mobile only"
          key="2"
          forceRender={true}>
          <section>
            <ImageUploadSection
              beforeImageUpload={beforeImageUpload}
              nest={['certificateImage']}
              path={`na-website/DiscoveryPage/v2/`}
              bucket={'image-assets.nasdaily.com'}
              form={form}
              hideResolution={{ desktop: true, mobile: true }}
              imgRequired={{ mobile: false, desktop: false }}
              showWebP={false}
              isDesktopInput={true}
            />
          </section>
        </Panel>
      </Collapse>
    </>
  );
};

export const renderCourseFormForFreeWorkshops = (form, setStatus) => {
  return (
    <>
      <section>
        <Form.Item
          label="Code"
          name="courseCode"
          rules={[
            { required: true, message: 'Please input course code!' }
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Title"
          name="courseTitle"
          rules={[
            { required: true, message: 'Please input course title!' }
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          name="courseDescription"
          rules={[
            { required: true, message: 'Please input course description!' }
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Discovery Description"
          name="discoveryDescription"
          rules={[
            {
              required: true,
              message: 'Please input discovery description!'
            }
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Uniersity"
          name="university"
          rules={[
            { required: true, message: 'Please input University!' }
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="By"
          name="by"
          rules={[{ required: true, message: 'By who?!' }]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Link"
          name="link"
          rules={[
            {
              required: false,
              message: 'Please input link!'
            }
          ]}>
          <Input />
        </Form.Item>

        <Form.Item
          label="Search tags"
          name="tags"
          rules={[
            {
              required: false,
              message: 'Please input search tags!'
            }
          ]}>
          <Input />
        </Form.Item>
      </section>
      <Collapse>
        <Panel
          header="thumbnailImgData (M:180x180) - mobile only"
          key="2"
          forceRender={true}>
          <section>
            <ImageUploadSection
              beforeImageUpload={beforeImageUpload}
              nest={['thumbnailImgData']}
              // Need to insert name of course here `ssr-academy/${courseName}/cohort/png/`
              path={`na-portal/CreatorBanners/`}
              bucket={'image-assets.nasdaily.com'}
              form={form}
              hideResolution={{ desktop: false, mobile: false }}
              imgRequired={{ mobile: true, desktop: false }}
              showWebP={false}
            />
          </section>
        </Panel>
      </Collapse>
      <Collapse>
        <Panel
          header="Top-left image in learning portal (Nav Bar Image)(M:120x120, D:240x240)  - mobile + desktop"
          key="2"
          forceRender={true}>
          <section>
            <ImageUploadSection
              beforeImageUpload={beforeImageUpload}
              nest={['learnPortalNavbarImgData']}
              // Need to insert name of course here `ssr-academy/${courseName}/cohort/png/`
              path={`na-portal/CreatorBanners/`}
              bucket={'image-assets.nasdaily.com'}
              form={form}
              hideResolution={{ desktop: false, mobile: false }}
              imgRequired={{ mobile: true, desktop: true }}
              showWebP={false}
            />
          </section>
        </Panel>
      </Collapse>
      <Collapse>
        <Panel
          header="overviewBannerImgData - image that appears in home page - if chosen workshop."
          key="2"
          forceRender={true}>
          <section>
            <ImageUploadSection
              beforeImageUpload={beforeImageUpload}
              nest={['overviewBannerImgData']}
              // Need to insert name of course here `ssr-academy/${courseName}/cohort/png/`
              path={`na-portal/CreatorBanners/`}
              bucket={'image-assets.nasdaily.com'}
              form={form}
              hideResolution={{ desktop: true, mobile: true }}
              imgRequired={{ mobile: true, desktop: true }}
              isDesktopInput={true}
              showWebP={false}
            />
          </section>
        </Panel>
      </Collapse>
      <Collapse>
        <Collapse>
          <Panel
            header="Search image in search dropdown (180x180) - mobile only"
            key="3"
            forceRender={true}>
            <section>
              <ImageUploadSection
                beforeImageUpload={beforeImageUpload}
                nest={['searchImgData']}
                path={`search/thumbnails/`}
                bucket={'image-assets.nasdaily.com'}
                setStatus={setStatus}
                hideResolution={{ desktop: true, mobile: false }}
                imgRequired={{ mobile: false, desktop: false }}
                form={form}
                showWebP={false}
              />
            </section>
          </Panel>
        </Collapse>
        <Panel
          header="Discovery Card Image (307x172) - mobile only"
          key="2"
          forceRender={true}>
          <section>
            <ImageUploadSection
              beforeImageUpload={beforeImageUpload}
              nest={['discoveryCardImgData']}
              // Need to insert name of course here `ssr-academy/${courseName}/cohort/png/`
              path={`na-website/DiscoveryPage/horizontal-thumbnails/`}
              bucket={'image-assets.nasdaily.com'}
              form={form}
              hideResolution={{ desktop: true, mobile: false }}
              imgRequired={{ mobile: false, desktop: false }}
              showWebP={false}
            />
          </section>
        </Panel>
      </Collapse>
      <Collapse>
        <Panel
          header="Avatar Image in discovery page(M:56x56,D:40x40) - M+D"
          key="2"
          forceRender={true}>
          <section>
            <ImageUploadSection
              beforeImageUpload={beforeImageUpload}
              nest={['avatarImgData']}
              path={`na-website/DiscoveryPage/v2/`}
              bucket={'image-assets.nasdaily.com'}
              form={form}
              hideResolution={{ desktop: false, mobile: false }}
              imgRequired={{ mobile: false, desktop: false }}
              isDesktopInput={true}
              showWebP={false}
            />
          </section>
        </Panel>
      </Collapse>
    </>
  );
};

export const renderCourseOfferFormForFreeWorkshops = (
  unitCount,
  form,
  setStatus
) => {
  return (
    <>
      <section>
        <Form.Item
          label="Code"
          name="courseOfferCode"
          rules={[
            { required: true, message: 'Please input course offer code!' }
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Description"
          name="courseOfferDescription"
          rules={[
            { required: true, message: 'Please input course description!' }
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Start Date (Local)"
          name="startDate"
          rules={[
            { required: true, message: 'Please input start date!' }
          ]}>
          <DatePicker
            showTime={true}
            showNow={false}
            format={dateFormat}
            style={{ width: '100%' }}
          />
        </Form.Item>
        {unitCount > 1 ? (
          <Form.Item
            label="End Date (Local)"
            name="endDate"
            rules={[
              { required: true, message: 'Please input end date!' }
            ]}>
            <DatePicker
              showTime={true}
              showNow={false}
              format={dateFormat}
              style={{ width: '100%' }}
            />
          </Form.Item>
        ) : (
          <Form.Item
            label="Session duration (in hours)"
            name="sessionDuration"
            rules={[
              {
                required: true,
                message: 'Please input session duration in hours!!'
              }
            ]}>
            <InputNumber />
          </Form.Item>
        )}

        <Form.Item
          label="Zoom Link"
          name="whereToGo"
          rules={[
            {
              required: true,
              message: 'Please input zoom link description!'
            }
          ]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="Wave"
          name="wave"
          rules={[
            { required: true, message: 'Please input course description!' }
          ]}>
          <InputNumber />
        </Form.Item>
      </section>
    </>
  );
};

export const formatData = (trainerExists, values) => {
  let endDate;
  let frequency;
  if (values.sessionDuration)
    endDate = moment(values.startDate)
      .add(values.sessionDuration, 'h')
      .toDate();
  else endDate = values.endDate;

  if (values.startDate) {
    frequency = [dayOfWeekMapInverse[values.startDate.weekday()]];
  } else frequency = ['Mon'];

  const user = {
    trainerObjectId: trainerExists ? values.trainerObjectId : null,
    trainer: !trainerExists
      ? {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          description: values.description,
          longDescription: values.longDescription,
          countryId: values.countryId,
          profileImage: values.profileImage,
          meetFacilitatorImg: values.meetFacilitatorImg
        }
      : null
  };

  const unit = {
    title: values.unitTitle,
    description: values.unitDescription,
    sectionNumber: 1,
    code: `${values.courseCode}01`,
    imgData: {
      alt: values.imgData?.alt,
      mobileImgData: {
        src: values.imgData?.mobileImgData?.src,
        webpSrc: values.imgData?.mobileImgData?.src,
        meta: { height: 185, width: 328 }
      }
    }
  };

  const subunit = {
    ...SUBUNIT_WORKSHOP_DEFAULTS,
    icon: values.certificateImage?.mobileImgData?.src,
    code: `${values.courseCode}01S03`,
    certificate: {
      ...CERTIFICATE_WORKSHOP_DEFAULTS,
      imgData: {
        mobileImgData: {
          webpSrc: values.certificateImage?.mobileImgData?.src,
          src: values.certificateImage?.mobileImgData?.src,
          meta: {
            width: 272,
            height: 182
          }
        },
        desktopImgData: {
          webpSrc: values.certificateImage?.mobileImgData?.src,
          src: values.certificateImage?.mobileImgData?.src,
          meta: {
            width: 240,
            height: 160
          }
        }
      }
    }
  };

  const course = {
    ...COURSE_WORKSHOP_DEFAULTS,
    code: values.courseCode,
    title: values.courseTitle,
    description: values.courseDescription,
    university: values.university,
    by: values.by,
    thumbnailImgData: values.thumbnailImgData,
    learnPortalNavbarImgData: values.learnPortalNavbarImgData,
    overviewBannerImgData: values.overviewBannerImgData,
    searchImgData: values.searchImgData,
    discoveryCardImgData: values.discoveryCardImgData,
    avatarImgData: values.avatarImgData,
    tags: values.tags,
    link: values.link,
    discoveryDescription: values.discoveryDescription
  };

  const courseOffer = {
    ...COURSE_OFFER_WORKSHOP_DEFAULTS,
    code: values.courseOfferCode,
    pricingOption: values.pricingOption,
    description: values.courseOfferDescription,
    startDate: values.startDate,
    endDate,
    frequency,
    whereToGo: values.whereToGo,
    wave: values.wave
  };

  return { user, unit, course, courseOffer, subunit };
};

export const formatUnitOfferPayload = (unitCreated, unitInserted) => {
  const startDate = moment(unitInserted.unitOfferStartDate);
  const endDate = moment(startDate).add(
    unitInserted.unitOfferSessionDuration,
    'h'
  );

  return {
    startDate,
    endDate,
    maxRegistrations: 24,
    minRegistrations: 10,
    unitId: unitCreated.unitId
  };
};
export const formatSingleUnitOfferPayload = (unitCreated, courseOffer) => {
  return {
    startDate: courseOffer.startDate,
    endDate: courseOffer.endDate,
    maxRegistrations: 24,
    minRegistrations: 10,
    unitId: unitCreated.unitId,
    courseOfferId: courseOffer.courseOfferId
  };
};
